<template>
  <div id="hasbeen">
    <div class="top clearfix">
      <div class="demo-input-suffix">
        <el-input placeholder="请输入内容" v-model="input1" @keyup.enter.native="searchGoods">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="search" @click="searchGoods">搜索</div>
      <div class="button">
        <el-button
          class="excelBtn batchShelve"
          type="primary"
          icon="el-icon-remove"
          @click="batchShelve"
        >批量上架</el-button>
        <el-button
          class="excelBtn"
          type="primary"
          v-show="checkStatus != 1"
          @click="confirmShelve"
        >确认上架</el-button>
        <!-- <el-button class="excelBtn" type="primary" icon="el-icon-plus">添加商品</el-button> -->
      </div>
    </div>
    <div>
      <div class="center">
        <el-table
          ref="tableData"
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :row-key="getRowKeys"
        >
          <el-table-column
            type="selection"
            width="55"
            v-if="checkStatus != 1"
            :reserve-selection="true"
            align="center"
          ></el-table-column>
          <el-table-column fixed prop="logo" label="主图" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.logo" width="80" height="80" />
            </template>
          </el-table-column>
          <el-table-column prop="goodName" label="名称" align="center"></el-table-column>
          <el-table-column prop="employeePrice" label="价格(元)" align="center"></el-table-column>
          <el-table-column prop="sale" label="总销量" align="center"></el-table-column>
          <el-table-column prop="updateTime" :formatter="dateFormat" label="上架时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="open(scope.row)" size="small">上架</el-button>
              <el-button type="text" size="small" @click="pushEdit(scope.row)">编辑</el-button>
              <el-button
                type="text"
                size="small"
                @click="editStock(scope.row)"
                :disabled="btnFalse"
              >修改库存</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <page 
      @clickPage="clickPage" 
      :currentPage="currentPage" 
      :pageSize="size" 
      :total="total" 
    />
    <el-dialog
      title="库存管理"
      :visible.sync="dialogFormVisible"
      @closed="handleClose"
      class="stock"
      width="30%"
    >
      <el-form ref="ruleForm">
        <el-form-item label="剩余库存">
          <span>{{stock}}</span>
        </el-form-item>
        <el-form-item label="修改库存">
          <el-radio-group v-model="radio" size="mini">
            <el-radio :label="0">增加</el-radio>
            <el-radio :label="1">减少</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="修改数量">
          <el-input placeholder="请输入修改数量" v-model="number"></el-input>
        </el-form-item>
        <el-form-item label="原因">
          <el-input type="textarea" v-model="text" placeholder="最多200字，选填" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="操作员">
          <span>{{userName}}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import page from "../../components/PageIndex";
import {
  tradeGoods,
  upadteGoodStatus,
  upadteGoodStock,
  getUserInfo,
  goodsShelve,
} from "../../api/goods";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    page,
  },
  created() {
    let sessionNum = sessionStorage.getItem("notonPage");
    if (!sessionNum) {
      this.getnoStoreList();
    } else {
      this.currentPage = Number(sessionNum);
      this.clickPage(this.currentPage);
    }
  },
  computed: {
    ...mapGetters(["chooseCompany", "companyList", "mchId"]),
  },
  data() {
    return {
      input1: "",
      currentPage: 1,
      size: 10,
      clear: false,
      total: 0,
      tableData: [],
      dialogFormVisible: false, // 库存弹框显隐
      radio: 0, // 修改类型
      number: "", // 修改数量
      text: "", // 修改原因
      goodId: "", // 商品ID
      stock: "", // 库存数
      userName: "", // 操作员
      btnFalse: false,
      checkStatus: 1, // 批量显示
      checkName: " 批量下架",
      hasSelectgoodsIdList: [],
      getRowKeys(row) {
        return row.goodId;
      },
      searchFlag: false
    };
  },
  methods: {
    handleClick(row) {
      console.log(row);
    },
    getnoStoreList() {
      let data = {
        goodName: this.input1 ? this.input1 : "",
        mchId: this.chooseCompany.id,
        page: this.searchFlag ? 1 : this.currentPage,
        pageCount: 10,
        status: 1,
        orderBy: 2,
        lifting: 1,
      };
      tradeGoods(data).then((val) => {
        this.tableData = val.data.list;
        this.tableData.forEach((item) => {
          item.employeePrice = this.regFenToYuan(item.employeePrice);
        });
        this.total = val.data.count[0].count;
        this.searchFlag = false;
      });
    },
    dateFormat: function (row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return this.$moment(parseInt(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    pushEdit(row) {
      const id = row.goodId;
      const status = row.status;
      this.$router.push({
        name: "Edits",
        query: { id, status }
      });
    },
    open(row) {
      const that = this;
      this.$confirm("是否上架该商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const id = row.goodId;
          upadteGoodStatus(id, 0).then(function (res) {
            if (res.code == 1) {
              that.$message({
                type: "success",
                message: "商品已上架!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消上架",
          });
        });
    },
    clickPage(val) {
      this.currentPage = val;
      window.sessionStorage.setItem("notonPage", val);
      this.getnoStoreList();
    },
    async editStock(row) {
      console.log(row);
      this.userInfo();
      this.dialogFormVisible = true;
      this.goodId = row.goodId;
      this.stock = row.stock;
      console.log(this.goodId);
    },
    handleClose() {
      this.dialogFormVisible = false;
    },
    handleSave(row) {
      this.btnFalse = true;
      if (this.number == 0) {
        this.$message("修改数量不能为空");
        return;
      }
      if (this.goodId == "") {
        this.$message("修改数量不能为空");
        return;
      }
      let data = {
        count: this.number,
        goodId: this.goodId,
        mark: this.text,
        type: this.radio === 0 ? 1 : 2,
      };
      upadteGoodStock(data)
        .then((res) => {
          if (res.code == 1) {
            this.$message("修改成功");
            this.dialogFormVisible = false;
            this.number = "";
            this.text = "";
            this.getnoStoreList();
            this.btnFalse = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.btnFalse = false;
        });
    },
    async userInfo() {
      let res = await getUserInfo();
      this.userName = res.data.nickName;
    },
    // 批量下架
    batchShelve() {
      this.checkStatus = this.checkStatus == 1 ? 0 : 1;
      // console.log(this.checkStatus);
    },
    // 确认上架
    confirmShelve() {
      if (!this.hasSelectgoodsIdList.length) {
        this.$message({
          message: "请选择上架商品",
        });
        return;
      }
      let that = this;
      this.$confirm("是否上架该商品", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const data = {
            goodIds: this.hasSelectgoodsIdList,
            status: 0,
          };
          goodsShelve(data).then(function (res) {
            if (res.msg == "success") {
              that.$message({
                type: "success",
                message: "商品已上架!",
              });
              that.getnoStoreList();
              that.checkStatus = 1;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消上架",
          });
        });
    },
    regFenToYuan(fen) {
      var num = fen;
      num = fen * 0.01;
      num += "";
      var reg =
        num.indexOf(".") > -1
          ? /(\d{1,3})(?=(?:\d{3})+\.)/g
          : /(\d{1,3})(?=(?:\d{3})+$)/g;
      num = num.replace(reg, "$1");
      num = this.toDecimal2(num);
      return num;
    },
    toDecimal2(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return false;
      }
      var f = Math.round(x * 100) / 100;
      var s = f.toString();
      var rs = s.indexOf(".");
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + 2) {
        s += "0";
      }
      return s;
    },
    // 选择商品
    handleSelectionChange(e) {
      if (e.length) {
        let goodsId = [];
        e.forEach((item) => {
          goodsId.push(item.goodId);
        });
        this.hasSelectgoodsIdList = goodsId;
        console.log(this.hasSelectgoodsIdList);
      }
    },
    searchGoods() {
      this.searchFlag = true;
      this.getnoStoreList()
    }
  },
};
</script>
<style lang="scss" scoped>
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

#hasbeen {
  width: 100%;
  height: 100%;
  padding: 27px 13px;
  box-sizing: border-box;
  .top {
    .demo-input-suffix {
      width: 220px;
      float: left;
    }
    .search {
      float: left;
      width: 50px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
    }
    .button {
      float: right;
      .excelBtn {
        width: 120px;
        background-color: #0891d7;
      }
    }
  }
  .center {
    margin-top: 25px;
  }
  .stock {
    /deep/ .el-form-item {
      margin-bottom: 22px;
      display: flex;
      .el-form-item__label {
        width: 100px;
      }
      .el-form-item__content {
        flex: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/store/notonList.vue